import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
  Alert,
  DialogContentText,
} from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import PasswordInput from '../PasswordInput';

interface RedefinirSenhaProps {
  open: boolean;
  onClose: () => void;
  tokenRecuperacao?: string | null;
}

const RedefinirSenha: React.FC<RedefinirSenhaProps> = ({
  open,
  onClose,
  tokenRecuperacao,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [token, setToken] = useState(tokenRecuperacao || '');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState<{
    type: 'error' | 'success';
    msg: string;
  } | null>(null);

  const clearAll = () => {
    onClose();
    setToken('');
    setNovaSenha('');
    setConfirmarSenha('');
    setSearchParams({});
    setFeedback(null);
    setLoading(false);
  };

  const handleRedefinir = async () => {
    setFeedback(null);
    if (!token || !novaSenha) {
      setFeedback({ type: 'error', msg: 'Preencha todos os campos.' });
      return;
    }
    if (novaSenha !== confirmarSenha) {
      setFeedback({ type: 'error', msg: 'As senhas não conferem.' });
      return;
    }

    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_OG_API_URL}/usuario-externo/redefinir-senha`;

      await axios.post(url, { token, newPassword: novaSenha });

      setFeedback({ type: 'success', msg: 'Senha alterada com sucesso!' });
      setTimeout(() => {
        clearAll();
      }, 1000);
    } catch (error: any) {
      setFeedback({
        type: 'error',
        msg: error.response?.data?.message || 'Token inválido ou expirado.',
      });
      setTimeout(() => {
        clearAll();
      }, 1000);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Redefinir Senha</DialogTitle>
      <DialogContent>
        <DialogContentText style={{ marginBottom: '1rem' }}>
          {tokenRecuperacao
            ? 'Informe a nova senha para sua conta.'
            : 'Verifique o link enviado para o seu e-mail.'}
        </DialogContentText>

        {feedback && (
          <Alert severity={feedback.type} style={{ marginBottom: '1rem' }}>
            {feedback.msg}
          </Alert>
        )}

        {tokenRecuperacao && (
          <>
            <PasswordInput
              fullWidth
              label="Nova Senha"
              margin="dense"
              value={novaSenha}
              onChange={e => setNovaSenha(e.target.value)}
              disabled={loading}
              required
            />

            <PasswordInput
              fullWidth
              label="Confirmar Nova Senha"
              margin="dense"
              value={confirmarSenha}
              onChange={e => setConfirmarSenha(e.target.value)}
              helperText="Confirme a nova senha."
              disabled={loading}
              required
            />
          </>
        )}
      </DialogContent>
      <DialogActions style={{ padding: '16px' }}>
        {tokenRecuperacao && (
          <>
            <Button onClick={onClose} color="inherit">
              Cancelar
            </Button>
            <Button
              onClick={handleRedefinir}
              variant="contained"
              color="primary"
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Salvar Nova Senha'}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default RedefinirSenha;
